import React, { lazy, Suspense } from "react";
import Loading from "./Loading";
import { Welcome } from "./Welcome";

const Events = lazy(() => import("./Events"))
const Contact = lazy(() => import("./Contact"))
const Links = lazy(() => import("./Links"))
const Manuals = lazy(() => import("./Manuals"))
const LegalNotice = lazy(() => import("./LegalNotice"))
const AboutLC = lazy(() => import("./AboutLC"))


export const MainWindow = (props) => {

    const { openPage, handleOpenPage, handleClosePage } = props;



    if (openPage.main === "events") {
        return (
            <Suspense fallback={<Loading />}>
                <Events
                    handleOpenPage={handleOpenPage}
                />
            </Suspense>
        )
    }
    if (openPage.main === "loading") {
        return (
            <Loading />
        )
    }
    if (openPage.main === "contact") {
        return (
            <Suspense fallback={<Loading />}>
                <Contact
                    pars={openPage.pars}
                    handleOpenPage={handleOpenPage}
                />
            </Suspense>
        )
    }
    if (openPage.main === "links" || openPage.main === "downloads") {
        return (
            <Suspense fallback={<Loading />}>
                <Links
                    type={openPage.main}
                />
            </Suspense>
        )
    }
    if (openPage.main === "manuals") {
        return (
            <Suspense fallback={<Loading />}>
                <Manuals />
            </Suspense>
        )
    }
    if (openPage.main === "legalNotice") {
        return (
            <Suspense fallback={<Loading />}>
                <LegalNotice />
            </Suspense>
        )
    }
    if (openPage.main === "newPage") {
        return (
            <Suspense fallback={<Loading />}>
            </Suspense>
        )
    }
    if (openPage.main === "aboutLC") {
        return (
            <Suspense fallback={<Loading />}>
                <AboutLC />
            </Suspense>
        )
    }



    // default is welcome
    return (
        <Welcome
            handleOpenPage={handleOpenPage}
            handleClosePage={handleClosePage}
        />
    );
}